module.exports = __webpack_public_path__ + "static/media/icon-logout.ae4ce795.svg";